import { EFeeClassFieldKind, TFeeClassField } from './types';

/** Numeric fields of the fee class form, rendered in this order. */
export const FEE_CLASS_NUMBER_FIELDS: TFeeClassField[] = [
	{
		name: 'importSchemeFixedFee',
		label: 'Import Scheme Fixed Fee',
		kind: EFeeClassFieldKind.AMOUNT,
	},
	{
		name: 'importPercentageFee',
		label: 'Import Percentage Fee (%)',
		kind: EFeeClassFieldKind.PERCENT,
	},
	{ name: 'unionFixedFee', label: 'Union Fixed Fee', kind: EFeeClassFieldKind.AMOUNT },
	{
		name: 'unionPercentageFee',
		label: 'Union Percentage Fee (%)',
		kind: EFeeClassFieldKind.PERCENT,
	},
	{ name: 'nonUnionFixedFee', label: 'Non-Union Fixed Fee', kind: EFeeClassFieldKind.AMOUNT },
	{
		name: 'nonUnionPercentageFee',
		label: 'Non-Union Percentage Fee (%)',
		kind: EFeeClassFieldKind.PERCENT,
	},
	{ name: 'b2cDomesticFixedFee', label: 'B2C Domestic Fixed Fee', kind: EFeeClassFieldKind.AMOUNT },
	{
		name: 'b2cDomesticPercentageFee',
		label: 'B2C Domestic Percentage Fee (%)',
		kind: EFeeClassFieldKind.PERCENT,
	},
	{ name: 'fcRepFixedFee', label: 'FC Rep Fixed Fee', kind: EFeeClassFieldKind.AMOUNT },
	{
		name: 'fcRepPercentageFee',
		label: 'FC Rep Percentage Fee (%)',
		kind: EFeeClassFieldKind.PERCENT,
	},
	{ name: 'minTradeValue', label: 'Min Trade Value', kind: EFeeClassFieldKind.AMOUNT },
	{ name: 'maxTradeValue', label: 'Max Trade Value', kind: EFeeClassFieldKind.AMOUNT },
	{ name: 'minOrderCount', label: 'Min Order Count', kind: EFeeClassFieldKind.COUNT },
	{ name: 'maxOrderCount', label: 'Max Order Count', kind: EFeeClassFieldKind.COUNT },
];

export const FIELD_STEP: Record<EFeeClassFieldKind, string> = {
	[EFeeClassFieldKind.AMOUNT]: '0.01',
	[EFeeClassFieldKind.PERCENT]: '0.01',
	[EFeeClassFieldKind.COUNT]: '1',
};
